query analyticsImpressionForCompany($input: GetAnalyticsImpressionInput!) {
  analyticsImpression: analyticsImpressionForCompany(input: $input) {
    overallTotal
    last30DaysTotal
    specificDateTotals {
      date
      count
    }
    utmTrafficCounts {
      utmKey
      values {
        label
        count
      }
    }
  }
}
